import { Injectable } from '@angular/core';
import { SystemStore } from '@frontend-site/shared/core';
import { ProjectInfo, SystemInfo, SystemTypes } from '@frontend-site/shared/data';
import { RememberLastPageProperties, LastPageGroup, PageId } from './entities/last-page';
import { LastPageVisitedService } from './services/last-page-visited.service';
import { LastSystemService } from './services/last-system.service';
import { ProjectLastPageVisitedService } from './services/project-last-page-visited.service';
import { SystemLastPageVisitedService } from './services/system-last-page-visited.service';

@Injectable({ providedIn: 'root' })
export class LastPagePersistenceFacade {
    constructor(
        private readonly systemStore: SystemStore,
        private readonly lastPageVisitedService: LastPageVisitedService,
        private readonly projectLastPageVisitedService: ProjectLastPageVisitedService,
        private readonly systemLastPageVisitedService: SystemLastPageVisitedService,
        private readonly lastSystemService: LastSystemService
    ) {}

    setLastPage(rememberMe: RememberLastPageProperties | boolean, path: string): void {
        this.lastPageVisitedService.set(path);
        if (this.systemStore.systemId) {
            this.lastSystemService.set(this.systemStore.systemId);
        }

        if (typeof rememberMe === 'object') {
            const { pageId, group } = rememberMe;
            this.setGroupedLastPageVisited(group, pageId);
        }
    }

    getLastPage(fallback: string = '/project'): string {
        const lastPage = this.lastPageVisitedService.get();

        if (!lastPage) {
            return fallback;
        }

        return lastPage;
    }

    getGroupedLastPageVisited(group: LastPageGroup): string | null | undefined {
        if (group === 'project') {
            return this.projectLastPageVisitedService.get();
        }
        if (group === 'system') {
            return this.systemLastPageVisitedService.get();
        }

        return null;
    }

    getLastSystem(): SystemInfo | null | undefined {
        return this.lastSystemService.get();
    }
    getLastSystemByType(systemType: SystemTypes): SystemInfo | null | undefined {
        return this.lastSystemService.getBySystemType(systemType);
    }
    getLastProjectInfo(): ProjectInfo | null {
        return this.projectLastPageVisitedService.getProjectInfo();
    }

    private setGroupedLastPageVisited(group: LastPageGroup, pageId: PageId): void {
        if (group === 'project') {
            this.projectLastPageVisitedService.set(pageId);
            return;
        }
        if (group === 'system') {
            this.systemLastPageVisitedService.set(pageId);
            return;
        }
    }
}
